/*!
 * @oarepo/invenio-oarepo-ui-quasar v1.3.3
 * (c) Miroslav Simek, CIS UCT Prague
 * Released under the MIT License.
 */
import { _ as _inherits, a as _createClass, b as _classCallCheck, c as _possibleConstructorReturn, d as _getPrototypeOf, e as _applyDecoratedDescriptor, f as _typeof, O as OARepoQuasarCollectionItem } from './chunk-06fe2861.js';
export { O as OARepoQuasarCollectionItem } from './chunk-06fe2861.js';
import Vue from 'vue';
import Component from 'vue-class-component';
import __vue_normalize__ from 'vue-runtime-helpers/dist/normalize-component.js';
import { Component as Component$1, Emit, Vue as Vue$1, Watch } from 'vue-property-decorator';
import sanitizeHtml from 'sanitize-html';
import { Query } from '@oarepo/invenio-oarepo-ui-vue';

var _dec, _class;
var OARepoQuasarCollection = (_dec = Component({
  name: 'oarepo-quasar-collection-list'
}), _dec(_class =
/*#__PURE__*/
function (_Vue) {
  _inherits(OARepoQuasarCollection, _Vue);

  function OARepoQuasarCollection() {
    _classCallCheck(this, OARepoQuasarCollection);

    return _possibleConstructorReturn(this, _getPrototypeOf(OARepoQuasarCollection).apply(this, arguments));
  }

  _createClass(OARepoQuasarCollection, [{
    key: "shownCollections",
    value: function shownCollections(collections) {
      return collections.filter(function (x) {
        return !x.hidden;
      });
    }
  }, {
    key: "locale",
    get: function get() {
      return this.$i18n.locale;
    }
  }]);

  return OARepoQuasarCollection;
}(Vue)) || _class);

/* script */
var __vue_script__ = OARepoQuasarCollection;
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('oarepo-collection-list', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(ref) {
        var collections = ref.collections;
        return [_c('div', {
          staticClass: "row justify-around"
        }, _vm._l(_vm.shownCollections(collections), function (collection) {
          return _c('q-card', {
            key: collection.code,
            staticClass: "q-ma-sm",
            staticStyle: {
              "max-width": "500px"
            },
            attrs: {
              "inline": "",
              "flat": "",
              "bordered": "",
              "square": ""
            }
          }, [_c('q-card-section', [_c('div', {
            staticClass: "text-h6"
          }, [_vm._v("\n                    " + _vm._s(collection.title[_vm.locale] || collection.title.en) + "\n                    ")])]), _vm._v(" "), _c('q-card-section', [_c('p', [_vm._v(_vm._s(collection.description[_vm.locale] || collection.description.en))])]), _vm._v(" "), _c('q-card-actions', [_c('q-btn', {
            attrs: {
              "flat": "",
              "color": "primary",
              "to": {
                name: 'collection',
                params: {
                  collectionCode: collection.code
                }
              }
            }
          }, [_vm._v("\n                    " + _vm._s(_vm.$t('message.collectionlist.open')) + "\n                ")])], 1)], 1);
        }), 1)];
      }
    }])
  });
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

var OARepoQuasarCollectionList = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, undefined, undefined);

var _dec$1, _dec2, _class$1, _class2;
var OARepoQuasarCollectionAbstractListItem = (_dec$1 = Component$1({
  props: {
    item: Object,
    mapping: Object,
    omitList: Boolean
  },
  components: {},
  name: 'oarepo-quasar-collection-abstract-list-item'
}), _dec2 = Emit('selected'), _dec$1(_class$1 = (_class2 =
/*#__PURE__*/
function (_Vue) {
  _inherits(OARepoQuasarCollectionAbstractListItem, _Vue);

  function OARepoQuasarCollectionAbstractListItem() {
    _classCallCheck(this, OARepoQuasarCollectionAbstractListItem);

    return _possibleConstructorReturn(this, _getPrototypeOf(OARepoQuasarCollectionAbstractListItem).apply(this, arguments));
  }

  _createClass(OARepoQuasarCollectionAbstractListItem, [{
    key: "selected",
    value: function selected(item) {
      return item;
    }
  }, {
    key: "component",
    get: function get() {
      var schema = this.item.metadata.$schema;

      if (this.mapping !== undefined && this.mapping[schema] !== undefined) {
        return this.mapping[schema];
      }

      return function () {
        return import('./OARepoQuasarCollectionItem-a8049d2e.js');
      };
    }
  }]);

  return OARepoQuasarCollectionAbstractListItem;
}(Vue$1), (_applyDecoratedDescriptor(_class2.prototype, "selected", [_dec2], Object.getOwnPropertyDescriptor(_class2.prototype, "selected"), _class2.prototype)), _class2)) || _class$1);

/* script */
var __vue_script__$1 = OARepoQuasarCollectionAbstractListItem;
/* template */

var __vue_render__$1 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.component ? _c(_vm.component, {
    tag: "component",
    attrs: {
      "item": _vm.item
    },
    on: {
      "selected": _vm.selected
    }
  }) : _vm._e();
};

var __vue_staticRenderFns__$1 = [];
/* style */

var __vue_inject_styles__$1 = undefined;
/* scoped */

var __vue_scope_id__$1 = undefined;
/* module identifier */

var __vue_module_identifier__$1 = undefined;
/* functional template */

var __vue_is_functional_template__$1 = false;
/* style inject */

/* style inject SSR */

var OARepoQuasarCollectionAbstractItem = __vue_normalize__({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, __vue_inject_styles__$1, __vue_script__$1, __vue_scope_id__$1, __vue_is_functional_template__$1, __vue_module_identifier__$1, undefined, undefined);

var _dec$2, _dec2$1, _dec3, _class$2, _class2$1, _temp;
var OARepoCollection = (_dec$2 = Component$1({
  props: {
    collectionCode: String,
    itemComponents: Object,
    omitList: Boolean
  },
  components: {
    'abstract-item': OARepoQuasarCollectionAbstractItem
  },
  name: 'oarepo-quasar-collection'
}), _dec2$1 = Emit('item-selected'), _dec3 = Watch('currentPage'), _dec$2(_class$2 = (_class2$1 = (_temp =
/*#__PURE__*/
function (_Vue) {
  _inherits(OARepoCollection, _Vue);

  function OARepoCollection() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, OARepoCollection);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(OARepoCollection)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.currentPage = 1;
    return _this;
  }

  _createClass(OARepoCollection, [{
    key: "sanitize",
    value: function sanitize(html) {
      return sanitizeHtml(html);
    }
  }, {
    key: "itemSelected",
    value: function itemSelected(item) {
      console.log('item selected called');
      return item;
    }
  }, {
    key: "gotoPage",
    value: function gotoPage() {
      var q = new Query(this.$route.query);
      q.replace('page', this.currentPage);
      this.$router.push({
        query: q.query
      });
    }
  }, {
    key: "locale",
    get: function get() {
      return this.$i18n.locale;
    }
  }, {
    key: "searchString",
    get: function get() {
      var q = new Query(this.$route.query);
      return q.get('q', true);
    }
  }, {
    key: "collectionLoading",
    get: function get() {
      return this.oarepo$.collectionModule.state !== 2;
    }
  }, {
    key: "totalPages",
    get: function get() {
      return this.oarepo$.collectionModule.totalPages;
    }
  }]);

  return OARepoCollection;
}(Vue), _temp), (_applyDecoratedDescriptor(_class2$1.prototype, "itemSelected", [_dec2$1], Object.getOwnPropertyDescriptor(_class2$1.prototype, "itemSelected"), _class2$1.prototype), _applyDecoratedDescriptor(_class2$1.prototype, "gotoPage", [_dec3], Object.getOwnPropertyDescriptor(_class2$1.prototype, "gotoPage"), _class2$1.prototype)), _class2$1)) || _class$2);

/* script */
var __vue_script__$2 = OARepoCollection;
/* template */

var __vue_render__$2 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('oarepo-collection', {
    ref: "oarepoCollection",
    attrs: {
      "collectionCode": _vm.collectionCode,
      "locale": _vm.locale
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(ref) {
        var collection = ref.collection;
        var items = ref.items;
        var aggregations = ref.aggregations;
        return [!_vm.collectionLoading ? _c('div', [_vm._t("title", [collection ? _c('h3', [_vm._v(_vm._s(collection.title[_vm.locale] || collection.title.en))]) : _vm._e()], {
          "collection": collection,
          "items": items,
          "aggregations": aggregations
        }), _vm._v(" "), _vm._t("content-before", null, {
          "collection": collection,
          "items": items
        }), _vm._v(" "), items.length > 0 ? _c('div', {
          staticClass: "row horiz wrap items-stretch"
        }, [_c('div', {
          staticClass: "col collection-content"
        }, [_vm._t("list-before", null, {
          "collection": collection
        }), _vm._v(" "), _vm.omitList ? _c('div', [_vm._t("list-header", null, {
          "collection": collection
        }), _vm._v(" "), _vm._l(items, function (item) {
          return _c('abstract-item', {
            key: "omit-" + item.id,
            attrs: {
              "item": item,
              "mapping": _vm.itemComponents,
              "omit-list": _vm.omitList
            },
            on: {
              "selected": function selected($event) {
                return _vm.itemSelected(item);
              }
            }
          });
        })], 2) : _c('q-list', [_vm._t("list-header", null, {
          "collection": collection
        }), _vm._v(" "), _vm._l(items, function (item) {
          return _c('abstract-item', {
            key: item.id,
            attrs: {
              "item": item,
              "mapping": _vm.itemComponents
            },
            on: {
              "selected": function selected($event) {
                return _vm.itemSelected(item);
              }
            }
          });
        })], 2), _vm._v(" "), _vm.totalPages ? _c('q-pagination', {
          staticClass: "pagination",
          attrs: {
            "color": "primary",
            "max": _vm.totalPages,
            "maxPages": 9,
            "boundaryNumbers": true,
            "boundaryLinks": true,
            "directionLinks": true,
            "size": "12px"
          },
          model: {
            value: _vm.currentPage,
            callback: function callback($$v) {
              _vm.currentPage = $$v;
            },
            expression: "currentPage"
          }
        }) : _vm._e(), _vm._v(" "), _vm._t("list-after", null, {
          "collection": collection
        })], 2), _vm._v(" "), _c('div', {
          staticClass: "aggs collection-facets"
        }, [_vm._t("search-before", null, {
          "collection": collection
        }), _vm._v(" "), _c('oarepo-quasar-search', {
          staticClass: "q-mb-lg",
          attrs: {
            "input": _vm.searchString
          }
        }), _vm._v(" "), _vm._t("facets-before", null, {
          "aggregations": aggregations,
          "collection": collection
        }), _vm._v(" "), _c('oarepo-quasar-facet-list', {
          attrs: {
            "facets": aggregations
          },
          scopedSlots: _vm._u([{
            key: "facetCard",
            fn: function fn(ref) {
              var facetKey = ref.facetKey;
              var values = ref.values;
              return [_vm._t("facetCard", null, {
                "facetKey": facetKey,
                ",": "",
                "values": values
              })];
            }
          }], null, true)
        }), _vm._v(" "), _vm._t("facets-after", null, {
          "collection": collection
        })], 2)]) : _vm._e(), _vm._v(" "), _vm._t("content-after", null, {
          "collection": collection
        })], 2) : _vm._e()];
      }
    }], null, true)
  });
};

var __vue_staticRenderFns__$2 = [];
/* style */

var __vue_inject_styles__$2 = undefined;
/* scoped */

var __vue_scope_id__$2 = "data-v-7f3ecb62";
/* module identifier */

var __vue_module_identifier__$2 = undefined;
/* functional template */

var __vue_is_functional_template__$2 = false;
/* style inject */

/* style inject SSR */

var OARepoQuasarCollection$1 = __vue_normalize__({
  render: __vue_render__$2,
  staticRenderFns: __vue_staticRenderFns__$2
}, __vue_inject_styles__$2, __vue_script__$2, __vue_scope_id__$2, __vue_is_functional_template__$2, __vue_module_identifier__$2, undefined, undefined);

var _dec$3, _dec2$2, _class$3, _class2$2;
var OARepoCollection$1 = (_dec$3 = Component$1({
  props: {
    collectionCode: String,
    itemId: String
  },
  name: 'oarepo-quasar-collection-item'
}), _dec2$2 = Emit('dataLoaded'), _dec$3(_class$3 = (_class2$2 =
/*#__PURE__*/
function (_Vue) {
  _inherits(OARepoCollection, _Vue);

  function OARepoCollection() {
    _classCallCheck(this, OARepoCollection);

    return _possibleConstructorReturn(this, _getPrototypeOf(OARepoCollection).apply(this, arguments));
  }

  _createClass(OARepoCollection, [{
    key: "sanitize",
    value: function sanitize(html) {
      return sanitizeHtml(html);
    }
  }, {
    key: "patch",
    value: async function patch(data) {
      return this.$refs.oarepoCollectionItem.patch(data);
    }
  }, {
    key: "dataLoaded",
    value: function dataLoaded() {
      return this.$refs.oarepoCollectionItem.item;
    }
  }, {
    key: "locale",
    // getters
    get: function get() {
      return this.$i18n.locale;
    }
  }]);

  return OARepoCollection;
}(Vue$1), (_applyDecoratedDescriptor(_class2$2.prototype, "dataLoaded", [_dec2$2], Object.getOwnPropertyDescriptor(_class2$2.prototype, "dataLoaded"), _class2$2.prototype)), _class2$2)) || _class$3);

/* script */
var __vue_script__$3 = OARepoCollection$1;
/* template */

var __vue_render__$3 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('oarepo-item', {
    ref: "oarepoCollectionItem",
    attrs: {
      "collectionCode": _vm.collectionCode,
      "itemId": _vm.itemId,
      "locale": _vm.locale
    },
    on: {
      "dataLoaded": _vm.dataLoaded
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(ref) {
        var collection = ref.collection;
        var item = ref.item;
        return [_vm._t("title", [_c('h3', [_c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.sanitize(item.metadata.title[_vm.locale] || item.metadata.title.en))
          }
        })])], {
          "collection": collection,
          "item": item
        }), _vm._v(" "), _vm._t("content-before", null, {
          "collection": collection,
          "item": item
        }), _vm._v(" "), _vm._t("raw-content", [_c('q-markup-table', {
          attrs: {
            "flat": "",
            "separator": "none"
          }
        }, [_c('tbody', _vm._l(item.metadata, function (value, key) {
          return _c('tr', {
            key: key
          }, [_c('th', {
            staticClass: "text-right vertical-top key"
          }, [_vm._v(_vm._s(_vm.$t('oarepo.item.' + key)))]), _vm._v(" "), _c('td', {
            staticClass: "text-left"
          }, [_c('oarepo-quasar-value-cell', {
            attrs: {
              "value": value
            }
          })], 1)]);
        }), 0)])], {
          "collection": collection,
          "item": item
        }), _vm._v(" "), _vm._t("content-after", null, {
          "collection": collection,
          "item": item
        })];
      }
    }], null, true)
  });
};

var __vue_staticRenderFns__$3 = [];
/* style */

var __vue_inject_styles__$3 = undefined;
/* scoped */

var __vue_scope_id__$3 = "data-v-3bfc15cc";
/* module identifier */

var __vue_module_identifier__$3 = undefined;
/* functional template */

var __vue_is_functional_template__$3 = false;
/* style inject */

/* style inject SSR */

var OARepoQuasarItem = __vue_normalize__({
  render: __vue_render__$3,
  staticRenderFns: __vue_staticRenderFns__$3
}, __vue_inject_styles__$3, __vue_script__$3, __vue_scope_id__$3, __vue_is_functional_template__$3, __vue_module_identifier__$3, undefined, undefined);

var _dec$4, _dec2$3, _class$4, _class2$3, _temp$1;
var LOCAL_STORAGE_KEY = 'oarepoFacetsOpenedModel';
var OARepoQuasarFacetList = (_dec$4 = Component({
  name: 'oarepo-quasar-facet-list',
  props: {
    facets: Object
  }
}), _dec2$3 = Watch('facets'), _dec$4(_class$4 = (_class2$3 = (_temp$1 =
/*#__PURE__*/
function (_Vue) {
  _inherits(OARepoQuasarFacetList, _Vue);

  function OARepoQuasarFacetList() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, OARepoQuasarFacetList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(OARepoQuasarFacetList)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.facetsOpenedModel = null;
    return _this;
  }

  _createClass(OARepoQuasarFacetList, [{
    key: "facetSelected",
    value: function facetSelected(bucketP, selected) {
      this.$refs.oarepoFacetList.facetSelected(bucketP, selected);
    }
  }, {
    key: "mounted",
    value: function mounted() {
      this.facetsOpenedModel = this.$q.localStorage.getItem(LOCAL_STORAGE_KEY);
    }
  }, {
    key: "facetsOpenedModelChanged",
    value: function facetsOpenedModelChanged() {
      if (this.facetsOpenedModel !== null) {
        this.$q.localStorage.set(LOCAL_STORAGE_KEY, this.facetsOpenedModel);
      }
    }
  }, {
    key: "facetsChanged",
    value: function facetsChanged(newValue) {
      var _this2 = this;

      if (this.facetsOpenedModel === null) {
        this.facetsOpenedModel = {};
      }

      Object.keys(newValue).forEach(function (key) {
        if (_this2.facetsOpenedModel[key] === undefined) {
          _this2.facetsOpenedModel[key] = true;
        }
      });
    }
  }]);

  return OARepoQuasarFacetList;
}(Vue), _temp$1), (_applyDecoratedDescriptor(_class2$3.prototype, "facetsChanged", [_dec2$3], Object.getOwnPropertyDescriptor(_class2$3.prototype, "facetsChanged"), _class2$3.prototype)), _class2$3)) || _class$4);

/* script */
var __vue_script__$4 = OARepoQuasarFacetList;
/* template */

var __vue_render__$4 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('oarepo-facet-list', {
    ref: "oarepoFacetList",
    attrs: {
      "facets": _vm.facets
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(ref) {
        var facets = ref.facets;
        return [_vm.facetsOpenedModel !== null ? _c('q-list', {
          attrs: {
            "bordered": ""
          }
        }, _vm._l(facets, function (val, key) {
          return _c('q-expansion-item', {
            key: key,
            attrs: {
              "expand-separator": "",
              "icon": "explore",
              "label": val.label
            },
            on: {
              "input": function input($event) {
                return _vm.facetsOpenedModelChanged();
              }
            },
            model: {
              value: _vm.facetsOpenedModel[key],
              callback: function callback($$v) {
                _vm.$set(_vm.facetsOpenedModel, key, $$v);
              },
              expression: "facetsOpenedModel[key]"
            }
          }, [_vm._t("facetCard", [_c('q-card', [_c('q-card-section', _vm._l(val.buckets, function (bucket) {
            return _c('div', {
              key: bucket.key
            }, [_vm._t("facetSelector", [_c('q-checkbox', {
              attrs: {
                "value": bucket.selected,
                "true-value": true,
                "false-value": false,
                "toggle-indeterminate": false
              },
              on: {
                "input": function input($event) {
                  return _vm.facetSelected(bucket, !bucket.selected);
                }
              }
            })], {
              "bucket": bucket,
              "facetKey": key
            }), _vm._v("\n                        " + _vm._s(bucket.label) + " (" + _vm._s(bucket.doc_count) + ")\n                    ")], 2);
          }), 0)], 1)], {
            "values": val,
            "facetKey": key
          })], 2);
        }), 1) : _vm._e()];
      }
    }], null, true)
  });
};

var __vue_staticRenderFns__$4 = [];
/* style */

var __vue_inject_styles__$4 = undefined;
/* scoped */

var __vue_scope_id__$4 = undefined;
/* module identifier */

var __vue_module_identifier__$4 = undefined;
/* functional template */

var __vue_is_functional_template__$4 = false;
/* style inject */

/* style inject SSR */

var OARepoQuasarFacetList$1 = __vue_normalize__({
  render: __vue_render__$4,
  staticRenderFns: __vue_staticRenderFns__$4
}, __vue_inject_styles__$4, __vue_script__$4, __vue_scope_id__$4, __vue_is_functional_template__$4, __vue_module_identifier__$4, undefined, undefined);

var _dec$5, _class$5;
var OARepoQuasarValueCell = (_dec$5 = Component({
  name: 'oarepo-quasar-value-cell',
  props: {
    value: [String, Object, Array, Number, Boolean]
  }
}), _dec$5(_class$5 =
/*#__PURE__*/
function (_Vue) {
  _inherits(OARepoQuasarValueCell, _Vue);

  function OARepoQuasarValueCell() {
    _classCallCheck(this, OARepoQuasarValueCell);

    return _possibleConstructorReturn(this, _getPrototypeOf(OARepoQuasarValueCell).apply(this, arguments));
  }

  _createClass(OARepoQuasarValueCell, [{
    key: "isArray",
    value: function isArray(x) {
      return Array.isArray(x);
    }
  }, {
    key: "isObject",
    value: function isObject(x) {
      return _typeof(x) === 'object';
    }
  }, {
    key: "isMultiLang",
    value: function isMultiLang(x) {
      return this.isObject(x) && !this.isArray(x) && !this.isPrimitive(x) && x._ !== undefined;
    }
  }, {
    key: "isPrimitive",
    value: function isPrimitive(x) {
      return x === null || !this.isArray(x) && !this.isObject(x);
    }
  }]);

  return OARepoQuasarValueCell;
}(Vue)) || _class$5);

/* script */
var __vue_script__$5 = OARepoQuasarValueCell;
/* template */

var __vue_render__$5 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "inline"
  }, [_vm.isPrimitive(_vm.value) ? _c('div', {
    staticClass: "primitive inline"
  }, [_vm._v("\n        " + _vm._s(_vm.value) + "\n    ")]) : _vm.isMultiLang(_vm.value) ? _c('div', [_vm._l(_vm.value, function (val, key) {
    return [key !== '_' ? _c('div', {
      key: key
    }, [_c('q-badge', {
      staticClass: "lang",
      attrs: {
        "align": "top"
      }
    }, [_vm._v(_vm._s(key))]), _vm._v("\n            " + _vm._s(val) + "\n        ")], 1) : _vm._e()];
  })], 2) : _vm.isArray(_vm.value) ? _c('div', _vm._l(_vm.value, function (item, index) {
    return _c('div', {
      key: index
    }, [_c('oarepo-quasar-value-cell', {
      attrs: {
        "value": item
      }
    })], 1);
  }), 0) : _vm.isObject(_vm.value) ? _c('div', {
    staticClass: "inline"
  }, _vm._l(_vm.value, function (val, key) {
    return _c('div', {
      key: key,
      staticClass: "inline"
    }, [_c('q-badge', {
      attrs: {
        "color": "grey"
      }
    }, [_vm._v(_vm._s(_vm.$t('oarepo.item.' + key)))]), _vm._v(" "), _c('oarepo-quasar-value-cell', {
      attrs: {
        "value": val
      }
    })], 1);
  }), 0) : _c('div', [_vm._v("\n        " + _vm._s(_vm.value) + "\n    ")])]);
};

var __vue_staticRenderFns__$5 = [];
/* style */

var __vue_inject_styles__$5 = undefined;
/* scoped */

var __vue_scope_id__$5 = undefined;
/* module identifier */

var __vue_module_identifier__$5 = undefined;
/* functional template */

var __vue_is_functional_template__$5 = false;
/* style inject */

/* style inject SSR */

var OARepoQuasarValueCell$1 = __vue_normalize__({
  render: __vue_render__$5,
  staticRenderFns: __vue_staticRenderFns__$5
}, __vue_inject_styles__$5, __vue_script__$5, __vue_scope_id__$5, __vue_is_functional_template__$5, __vue_module_identifier__$5, undefined, undefined);

var _dec$6, _dec2$4, _class$6, _class2$4, _temp$2;
var OARepoQuasarSearch = (_dec$6 = Component$1({
  name: 'oarepo-quasar-search',
  props: {
    input: String
  }
}), _dec2$4 = Watch('input'), _dec$6(_class$6 = (_class2$4 = (_temp$2 =
/*#__PURE__*/
function (_Vue) {
  _inherits(OARepoQuasarSearch, _Vue);

  function OARepoQuasarSearch() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, OARepoQuasarSearch);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(OARepoQuasarSearch)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.queryString = '';
    return _this;
  }

  _createClass(OARepoQuasarSearch, [{
    key: "entered",
    value: function entered() {
      var q = new Query(this.$route.query);
      q.replace('q', this.queryString);
      console.log(q.query);
      this.$router.push({
        query: q.query
      });
    }
  }, {
    key: "inputChanged",
    value: function inputChanged() {
      this.queryString = this.input;
    }
  }, {
    key: "mounted",
    value: function mounted() {
      this.inputChanged();
    }
  }]);

  return OARepoQuasarSearch;
}(Vue$1), _temp$2), (_applyDecoratedDescriptor(_class2$4.prototype, "inputChanged", [_dec2$4], Object.getOwnPropertyDescriptor(_class2$4.prototype, "inputChanged"), _class2$4.prototype)), _class2$4)) || _class$6);

/* script */
var __vue_script__$6 = OARepoQuasarSearch;
/* template */

var __vue_render__$6 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('q-input', {
    attrs: {
      "label": _vm.$t('message.search')
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }

        return _vm.entered($event);
      }
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function fn() {
        return [_c('q-avatar', [_c('q-icon', {
          attrs: {
            "name": "search"
          }
        })], 1)];
      },
      proxy: true
    }]),
    model: {
      value: _vm.queryString,
      callback: function callback($$v) {
        _vm.queryString = $$v;
      },
      expression: "queryString"
    }
  })], 1);
};

var __vue_staticRenderFns__$6 = [];
/* style */

var __vue_inject_styles__$6 = undefined;
/* scoped */

var __vue_scope_id__$6 = undefined;
/* module identifier */

var __vue_module_identifier__$6 = undefined;
/* functional template */

var __vue_is_functional_template__$6 = false;
/* style inject */

/* style inject SSR */

var OARepoQuasarSearch$1 = __vue_normalize__({
  render: __vue_render__$6,
  staticRenderFns: __vue_staticRenderFns__$6
}, __vue_inject_styles__$6, __vue_script__$6, __vue_scope_id__$6, __vue_is_functional_template__$6, __vue_module_identifier__$6, undefined, undefined);

/**
 *
 * OARepo vue.js default components to be used in vuejs based client for invenio repository
 *
 */
var OARepoQuasar = {
  install: function install(Vue) {
    Vue.component('oarepo-quasar-collection-list', OARepoQuasarCollectionList);
    Vue.component('oarepo-quasar-collection', OARepoQuasarCollection$1);
    Vue.component('oarepo-quasar-item', OARepoQuasarItem);
    Vue.component('oarepo-quasar-collection-item', OARepoQuasarCollectionItem);
    Vue.component('oarepo-quasar-facet-list', OARepoQuasarFacetList$1);
    Vue.component('oarepo-quasar-value-cell', OARepoQuasarValueCell$1);
    Vue.component('oarepo-quasar-search', OARepoQuasarSearch$1);
  }
};

export { OARepoQuasar, OARepoQuasarCollection$1 as OARepoQuasarCollection, OARepoQuasarCollectionList, OARepoQuasarFacetList$1 as OARepoQuasarFacetList, OARepoQuasarItem, OARepoQuasarValueCell$1 as OARepoQuasarValueCell };
